import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { ButtonIconPositions } from '../../interfaces/button-icon-position.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() text: string;
  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() minWidth = 110;
  @Input() minHeight = 38;
  @Input() icon: string; // icon svg from assets
  @Input() type: 'button' | 'submit' = 'button'; // for 'submit' you don't need Output clicked()
  @Input() animateClass: 'animation-focus-default' | 'none' = 'animation-focus-default';
  @Input() styleClass: 'default' | 'settings' | 'toggle' = 'default';
  @Input() justifyTextPosition: 'center' | 'left' = 'center';
  @Input() iconInCenter: boolean;
  @Input() iconPosition: ButtonIconPositions = ButtonIconPositions.Left;

  ButtonIconPositions = ButtonIconPositions;

  // for styleClass === default
  // 'primary' | 'secondary' | 'white' | 'transparent'
  // for styleClass === settings
  // 'blue' | 'red'
  // for styleClass === toggle
  // 'active'
  @Input() subStyle: 'primary' | 'secondary' | 'white' | 'transparent' | 'blue' | 'red' | 'active' | 'unactive' | 'white-light-text' | 'white-with-red-border' |
  'white-primary-text-border' | 'green' = 'primary';
  @Input() customClasses = ''; // any classes, e.g. tailwind that you want to apply to <button>

  @Input() set focused(value) {
    if (value) {
      this.focus();
    }
  }

  @Output() clicked: EventEmitter<void> = new EventEmitter();
  @Output() keydownTab: EventEmitter<void> = new EventEmitter();

  @ViewChild('appButton') appButton;

  constructor() {
  }

  focus(): void {
    setTimeout(() => this.appButton.nativeElement.focus());
  }
}
